var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
/**
 * Translate a string.
 */
export function t(translation, id) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var string = translation[id];
    if (!string) {
        throw new Error("Translation not found for \"".concat(id, "\""));
    }
    // Now we are going to replace the arguments
    // but we want to return a string as long as it's possible
    // (eg. if there isn't any argument that is a ReactNode)
    var parts = [];
    var currentStringToReplace = string;
    args.forEach(function (arg, i) {
        if (typeof arg === 'string') {
            currentStringToReplace = currentStringToReplace.replace("${".concat(i + 1, "}"), arg);
        }
        else {
            var _a = currentStringToReplace.split("${".concat(i + 1, "}")), partToPush = _a[0], partToReplace = _a[1];
            if (partToPush === undefined || partToReplace === undefined) {
                throw new Error("Invalid translation \"".concat(id, "\""));
            }
            parts.push(<React.Fragment key={"string-".concat(i)}>{partToPush}</React.Fragment>);
            parts.push(<React.Fragment key={"arg-".concat(i)}>{arg}</React.Fragment>);
            currentStringToReplace = partToReplace;
        }
    });
    if (!parts.length) {
        return currentStringToReplace;
    }
    return (<>
            {parts}
            {currentStringToReplace}
        </>);
}
/**
 * Version of `t` that returns a string.
 */
export function tString(translation, id) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var result = t.apply(void 0, __spreadArray([translation, id], args, false));
    return reactToString(result);
}
function reactToString(el) {
    if (typeof el === 'string' || typeof el === 'number' || typeof el === 'boolean') {
        return "".concat(el);
    }
    if (el === null || el === undefined) {
        return '';
    }
    if (Array.isArray(el)) {
        return el.map(reactToString).join('');
    }
    if (typeof el === 'object' && 'props' in el) {
        return el.props.children.map(reactToString).join('');
    }
    throw new Error("Unsupported type ".concat(typeof el));
}
